import { createContext, useContext } from 'react';
import { dailyRoutineStepId } from 'domains/dailyRoutines/steps';
import { TypeActivityOfDailyLivingFields, TypeLearningPathsFields } from 'types/contentful/clinical';
import { UseCompletableWizardResult } from 'utils/hooks/useCompletableWizard';
import { AssignmentFeedback } from 'domains/assignments/types';

type DailyRoutineContext = {
  dailyRoutineContent: TypeActivityOfDailyLivingFields;
  learningPathContent: TypeLearningPathsFields;
  onComplete: (feedbackData: AssignmentFeedback) => void;
  previewMode: boolean;
} & UseCompletableWizardResult;

export const DailyRoutineCtx = createContext({} as DailyRoutineContext);

export const withDailyRoutineContext = (Component: React.FC, matchingStep: dailyRoutineStepId) => {
  return (props: Record<string, unknown>) => {
    const { currentStep } = useContext(DailyRoutineCtx);

    if (matchingStep === currentStep) {
      return <Component {...props} />;
    }

    return null;
  };
};
